// Server clock estimate (M1-10 lite): serverNow = local ms + offset.
// Seeded from Welcome.roomMs, refined by Ping/Pong; the min-RTT sample of the
// last few wins (least queueing noise).
export class ClockSync {
    constructor(local = () => performance.now(), keep = 8) {
        this.local = local;
        this.keep = keep;
        this.samples = [];
        this.offset = 0;
        this.rtt = NaN;
        this.synced = false;
    }
    seed(roomMs) {
        if (this.samples.length === 0) {
            this.offset = roomMs - this.local();
            this.synced = true;
        }
    }
    // Pong {c: client ms when sent, s: server RoomMs at receipt}.
    onPong(msg, now = this.local()) {
        const rtt = now - msg.c;
        if (!(rtt >= 0) || !Number.isFinite(msg.s)) return;
        this.samples.push({ rtt, offset: msg.s + rtt / 2 - now });
        if (this.samples.length > this.keep) this.samples.shift();
        let best = this.samples[0];
        for (const s of this.samples) if (s.rtt < best.rtt) best = s;
        this.offset = best.offset;
        this.rtt = best.rtt;
        this.synced = true;
    }
    now() {
        return this.local() + this.offset;
    }
}
